import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=17308f64&scoped=true&"
import script from "./InputCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17308f64",
  null
  
)

export default component.exports